import type { ExportToDocumentationResultData } from 'shared/domain/issue/linkedDocumentation/operations';

function readStringField(
  source: Record<string, unknown>,
  ...keys: string[]
): string | undefined {
  for (const key of keys) {
    const value = source[key];
    if (typeof value === 'string' && value.trim()) {
      return value;
    }
  }

  return undefined;
}

export function normalizeExportToDocumentationResult(
  response: unknown
): ExportToDocumentationResultData {
  if (!response || typeof response !== 'object') {
    throw new Error('Invalid export to documentation response');
  }

  const record = response as Record<string, unknown>;
  const nestedCandidate = record.data ?? record.item ?? record.result;
  const nested =
    nestedCandidate && typeof nestedCandidate === 'object'
      ? (nestedCandidate as Record<string, unknown>)
      : undefined;

  const documentationRecord =
    nested?.documentation && typeof nested.documentation === 'object'
      ? (nested.documentation as Record<string, unknown>)
      : undefined;
  const versionRecord =
    nested?.version && typeof nested.version === 'object'
      ? (nested.version as Record<string, unknown>)
      : undefined;

  const source = nested ?? record;
  const documentationId =
    readStringField(source, 'documentationId') ??
    (documentationRecord
      ? readStringField(documentationRecord, '_id', 'id')
      : undefined);
  const versionId =
    readStringField(source, 'versionId') ??
    (versionRecord ? readStringField(versionRecord, '_id', 'id') : undefined);

  if (!documentationId || !versionId) {
    throw new Error('Export to documentation response is missing ids');
  }

  const documentationName =
    readStringField(source, 'documentationName', 'name') ??
    (documentationRecord
      ? readStringField(documentationRecord, 'name', 'documentationName')
      : undefined);

  return {
    documentationId,
    versionId,
    ...(documentationName ? { documentationName } : {}),
  };
}
